import { TRole } from '@newo/api/gateway';

export const ROLES = [
    { value: 'owner', label: 'Owner', color: 'blue' },
    { value: 'account_manager', label: 'Account Manager', color: 'orange' },
    { value: 'technical_owner', label: 'Technical Owner', color: 'cyan' },
    { value: 'technical_support', label: 'Technical Support', color: 'teal' },
    { value: 'viewer', label: 'Viewer', color: 'gray' }
];

export const ROLE_COLORS: Record<TRole, string> = {
    owner: 'blue',
    referral: 'gray',
    account_manager: 'orange',
    technical_owner: 'cyan',
    technical_support: 'teal',
    viewer: 'gray'
};
